import {NgModule} from "@angular/core";

import { CommonModule } from "@angular/common";
import { AppTranslationModule } from "app/app.translation.module";
import { BreadcrumbComponent } from './breadcrumb.component';
import { CrumbItemComponent } from './crumb-item.component';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    BreadcrumbComponent,
    CrumbItemComponent
  ],
  imports: [  
    CommonModule,
    AppTranslationModule,
    RouterModule
  ], 
  exports: [    
    BreadcrumbComponent,
    CrumbItemComponent
  ],
})

export class BreadcrumbModule {

}
